<script setup lang="ts">
defineProps<{
  selectedTemplate: number;
  templates: Array<{ name: string; bg: string; accent: string; logo: string; image?: string }>;
}>();

defineEmits<{
  (e: 'select-template', idx: number): void;
}>();
</script>

<template>
  <div class="templates-stage-mock dark">
     <!-- Template Search (Desktop Only) -->
     <div class="search-templates-mock dark hide-mobile">
        <span>Filter templates...</span>
     </div>
     
     <!-- Template Grid -->
     <div class="templates-grid-mock dark">
        <div 
          v-for="(t, idx) in templates" 
          :key="t.name" 
          :class="['template-card-mock dark', { active: selectedTemplate === idx }]"
          @click="$emit('select-template', idx)"
        >
          <div 
            class="template-thumb-mock dark" 
            :style="{ backgroundImage: `url(${t.image})` }"
          >
             <div class="sample-badge">SAMPLE ONLY</div>
          </div>
          <span class="template-name">{{ t.name }}</span>
        </div>
     </div>
  </div>
</template>

<style scoped>
.templates-stage-mock { display: flex; flex-direction: column; gap: 24px; height: 100%; }
.search-templates-mock { background: #000; border: 1px solid #27272a; padding: 14px 20px; border-radius: 12px; color: #71717a; font-size: 0.95rem; }
.templates-grid-mock { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; flex-grow: 1; overflow-y: auto; }
.template-card-mock { background: #18181b; border-radius: 14px; padding: 4px; border: 2px solid transparent; cursor: pointer; display: flex; flex-direction: column; gap: 8px; }
.template-card-mock.active { border-color: #e21b0d; }
.template-thumb-mock { aspect-ratio: 9/16; border-radius: 10px; background-size: cover; background-position: center; position: relative; overflow: hidden; display: flex; align-items: center; justify-content: center; }
.sample-badge { position: absolute; bottom: 30%; left: 50%; transform: translateX(-50%) rotate(-15deg); background: rgba(255,255,255,0.2); backdrop-filter: blur(4px); padding: 4px 12px; border: 1px solid rgba(255,255,255,0.4); font-size: 0.65rem; font-weight: 900; color: #fff; white-space: nowrap; border-radius: 4px; pointer-events: none; }
.template-name { padding: 4px 8px 8px; font-size: 0.75rem; font-weight: 700; color: #fff; }

@media (max-width: 768px) {
  .templates-stage-mock { padding: 16px; gap: 16px; }
  .templates-grid-mock { grid-template-columns: repeat(2, 1fr); gap: 12px; }
  .hide-mobile { display: none !important; }
}
</style>
